import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import RedClockIcon from '@assets/images/redClock.svg';
import YellowClockIcon from '@assets/images/yellowClock.svg';
import GreenClockIcon from '@assets/images/greenClock.svg';
import moment from 'moment';
import CustomTypography from '../lib/ui-components/Typography/CustomTypography';

interface TimeDifferenceProps {
  createdOn: string;
  waitEndTime: string;
  isWaitingRoom?: boolean;
}

const getTimeDifference = (
  startTimeStr: string | null,
  endTimeStr: string | null
): { hours: number; minutes: number; totalMinutes: number } => {
  if (startTimeStr === null || endTimeStr === null) {
    return { hours: 0, minutes: 0, totalMinutes: 0 };
  }
  const startTime = moment.utc(startTimeStr).local().valueOf();
  const endTime = moment.utc(endTimeStr).local().valueOf();

  const differenceInMilliseconds = endTime - startTime;

  const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
  const hours = Math.floor(differenceInSeconds / 3600);
  const minutes = Math.floor((differenceInSeconds % 3600) / 60);
  const totalMinutes = Math.floor(differenceInSeconds / 60);
  return { hours, minutes, totalMinutes };
};

const TimeDifference: React.FC<TimeDifferenceProps> = ({
  createdOn,
  waitEndTime,
  isWaitingRoom = false,
}) => {
  const { hours, minutes, totalMinutes } = getTimeDifference(
    createdOn,
    waitEndTime
  );
  const [timerColor, setTimerColor] = useState('#21BB6E'); // Default color
  const [timerIcon, setTimerIcon] = useState('green');

  useEffect(() => {
    if (totalMinutes < 90) {
      setTimerColor('#21BB6E');
      setTimerIcon('green');
    } else if (totalMinutes >= 90 && totalMinutes < 180) {
      setTimerColor('#E1A500');
      setTimerIcon('yellow');
    } else {
      setTimerColor('#EB4C60');
      setTimerIcon('red');
    }
  }, [totalMinutes]);

  const formattedTime = isWaitingRoom
    ? `${String(hours).padStart(2, '0')}h:${String(minutes).padStart(2, '0')}m`
    : `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

  let ClockIcon;

  if (timerIcon === 'red') {
    ClockIcon = <RedClockIcon />;
  } else if (timerIcon === 'yellow') {
    ClockIcon = <YellowClockIcon />;
  } else {
    ClockIcon = <GreenClockIcon />;
  }

  if (isWaitingRoom) {
    return <>{formattedTime}</>;
  }

  return (
    <Box
      style={
        {
          display: 'flex',
          gap: '4px',
          '--timer-color': timerColor,
        } as React.CSSProperties
      }
    >
      {formattedTime && ClockIcon}
      <CustomTypography variant="body2" id="waitingTimeTick">
        <span style={{ color: timerColor }}>{formattedTime}</span>
      </CustomTypography>
    </Box>
  );
};

export default TimeDifference;
